export default "__VITE_ASSET__BFCQGzL$__"